const TRANSFER_BASE_URL_PLACEHOLDER = '__VITE_APP_TRANSFER_BASE_URL__';

/**
 * Base URL for file upload/download (transfer) operations.
 * Uses `VITE_APP_TRANSFER_BASE_URL` when set; otherwise falls back to
 * `VITE_APP_API_BASE_URL` (same host transfer endpoints used before).
 */
export function getTransferBaseUrl(): string {
  const transferBaseUrl = String(import.meta.env.VITE_APP_TRANSFER_BASE_URL ?? '').trim();
  if (transferBaseUrl && transferBaseUrl !== TRANSFER_BASE_URL_PLACEHOLDER) {
    return transferBaseUrl;
  }
  // Always return a string — Vitest/CI may leave VITE_APP_API_BASE_URL unset.
  return String(import.meta.env.VITE_APP_API_BASE_URL ?? '').trim();
}
